import React from 'react';
import '../../styles/layout.css';

/**
 * RowElement - Horizontal container with 12-column grid
 * Always uses 12 columns, children specify span (1-12)
 */
const RowElement = ({ element, children, isEditorMode }) => {
  const { props } = element;
  const {
    gap = 'medium',
    alignment = 'stretch',
    reverseOnMobile = false
  } = props || {};

  return (
    <div
      className={`builder-row ${isEditorMode ? 'builder-editor-mode' : ''}`}
      data-gap={gap}
      data-alignment={alignment}
      data-reverse-mobile={reverseOnMobile}
    >
      {children}
    </div>
  );
};

export default RowElement;
